/** Central app branding — name, taglines, and logo paths used across the UI. */

const rawName = process.env.REACT_APP_LOGONAME || 'Bahlus';
export const APP_NAME = String(rawName).replace(/^["']|["']$/g, '').trim() || 'Bahlus';

export const APP_TAGLINE = 'MEET, SHARE AND GROW';
export const APP_DESCRIPTION =
  'A forum for open discussions, clubs, and shared stories — where curiosity meets community.';

export const HERO_HEADLINE = 'The place where minds connect';
export const HERO_DESCRIPTION =
  'Ask questions, swap perspectives, and build belonging in spaces made for real dialogue — not noise.';

export const HERO_HIGHLIGHTS = [
  'Open discussions',
  'Clubs & communities',
  'Stories & shared knowledge',
];

export const SIGNIN_CARD_SUBTITLE = 'Sign in to join the conversation';

const publicUrl = process.env.PUBLIC_URL || '';
/** Bump when favicon assets change to bust aggressive browser caches. */
export const FAVICON_VERSION = '5';
const faviconQuery = `?v=${FAVICON_VERSION}`;

export const LOGO_SRC = `${publicUrl}/bahlus-logo.svg`;
export const LOGO_ICON_SRC = `${publicUrl}/bahlus-icon.svg?v=${FAVICON_VERSION}`;
export const FAVICON_ICO_SRC = `${publicUrl}/favicon.ico${faviconQuery}`;
export const FAVICON_PNG_SRC = `${publicUrl}/favicon-32x32.png${faviconQuery}`;
export const FAVICON_SVG_SRC = `${publicUrl}/bahlus-icon.svg${faviconQuery}`;
export const APPLE_TOUCH_ICON_SRC = `${publicUrl}/apple-touch-icon.png${faviconQuery}`;
export const MANIFEST_SRC = `${publicUrl}/manifest.json${faviconQuery}`;

/** Present calendar year for copyright notices (evaluated at call time). */
export function getCurrentYear() {
  return new Date().getFullYear();
}
